import request from "@/utils/interceptor.js";

// 人员进入
export function postchanneldetectionstatistics(data) {
  return request({
    url: "/channeldetectionstatistics",
    method: "post",
    data,
  });
}
// 实际检测人数
export function postdetectionsummary(data) {
  return request({
    url: "/detectionsummary",
    method: "post",
    data,
  });
}
// 预警记录
export function postwarningrecords(data) {
  return request({
    url: "/warningrecords",
    method: "post",
    data,
  });
}
// 监控预警
export function postWarningsummary(data) {
  return request({
    url: "/warningsummary",
    method: "post",
    data,
  });
}
// 监控异常
export function postwarninghourlystatistics(data) {
  return request({
    url: "/warninghourlystatistics",
    method: "post",
    data,
  });
}
// 人员列表
export function postThreesecondswarningorders(data) {
  return request({
    url: "/threesecondswarningorders",
    method: "post",
    data,
  });
}
// 组织总人数
export function getTesterThreeSecondsEvaluation(params) {
  return request({
    url: "/api/pas/tester-three-seconds-evaluation",
    method: "get",
    params,
  });
}
// 通道列表
export function getThreeSecondsEvaluationChannel(params) {
  return request({
    url: "/api/pas/three-seconds-evaluation-channel",
    method: "get",
    params,
  });
}
//新增通道
export function postThreeSecondsEvaluationChannel(data) {
  return request({
    url: "/api/pas/three-seconds-evaluation-channel",
    method: "post",
    data,
  });
}
//更新通道
export function putThreeSecondsEvaluationChannel(data) {
  return request({
    url: `/api/pas/three-seconds-evaluation-channel/${data.id}`,
    method: "put",
    data,
  });
}
//删除通道
export function deleteThreeSecondsEvaluationChannel(id) {
  return request({
    url: `/api/pas/three-seconds-evaluation-channel/${id}`,
    method: "delete",
  });
}
//海康通道列表
export function getHikvisionChannels(params) {
  return request({
    url: `/api/app/hikvision/channels`,
    method: "get",
    params
  });
}
//海康通道列表
export function postHikvisionChannels(data) {
  return request({
    url: `/api/app/hikvision/channels/bind`,
    method: "post",
    data
  });
}

